import { FiLock, FiFileText, FiRefreshCw, FiSliders, FiArchive, FiShield } from 'react-icons/fi';

// Public legal documents, in the order they are listed in the Legal Center. Text comes from legalDocs.generated.js.
// `seo` is the PAGE_SEO key; `group` decides the Legal Center section.
const LEGAL_DOCS = [
  { slug: 'privacy', path: '/privacy', name: 'Privacy Policy', seo: 'privacy', icon: FiLock, group: 'everyone',
    summary: 'What personal data we process for schools, students, parents and staff, why, and your rights under the DPDP Act, 2023.' },
  { slug: 'terms', path: '/terms', name: 'Terms and Conditions', seo: 'terms', icon: FiFileText, group: 'everyone',
    summary: 'The rules for using PRO SOLUTIONS ERP: accounts, acceptable use, fees, liability, termination and disputes.' },
  { slug: 'cookie-policy', path: '/cookie-policy', name: 'Cookie Policy', seo: 'cookiePolicy', icon: FiSliders, group: 'everyone',
    summary: 'The cookies our website and apps use, and how to accept or refuse the optional ones.' },
  { slug: 'refund-policy', path: '/refund-policy', name: 'Refund and Cancellation Policy', seo: 'refundPolicy', icon: FiRefreshCw, group: 'institutions',
    summary: 'When an institution can cancel, when money is returned, and how data export works after cancellation.' },
  { slug: 'data-security', path: '/data-security', name: 'Security and Trust Overview', seo: 'dataSecurity', icon: FiShield, group: 'institutions',
    summary: 'How data is protected, shown honestly as in place, in progress or planned.' },
  { slug: 'data-retention', path: '/data-retention', name: 'Data Retention and Requests', seo: 'dataRetention', icon: FiArchive, group: 'institutions',
    summary: 'How long each kind of record is kept, and how access, correction and deletion requests are handled.' },
];

export const LEGAL_GROUPS = [
  { id: 'everyone', title: 'For everyone', text: 'Visitors, parents, students, teachers and staff.' },
  { id: 'institutions', title: 'For institutions', text: 'Schools and colleges that subscribe to PRO SOLUTIONS ERP.' },
];

export default LEGAL_DOCS;
